/**
 * Cannot use a namespace here because Typescript namespaces don't support re-exporting for some reason
 */
import { ClientConfigProvider } from '../ClientConfigProvider';
import * as RuntimeConfigurationService from '../RuntimeConfigurationService/RuntimeConfigurationService.server';
import { APIConfigurationServiceDomain } from './domain';

export type { APIConfigurationServiceDomain as Domain };
export class ConfigProvider extends ClientConfigProvider {
    public get services(): APIConfigurationServiceDomain.SupportedServices {
        return this.getServicesForEnvironment(this.runtimeConfig.deploymentEnvironment);
    }

    private getServicesForEnvironment(
        environment: RuntimeConfigurationService.Domain.DeploymentEnvironment
    ): APIConfigurationServiceDomain.SupportedServices {
        return APIConfigurationServiceDomain.DEPLOYMENT_ENVIRONMENT_TO_SERVICES[environment];
    }
}
